import axios from "axios";
import {APP_URL} from "../common/contant"

const root = APP_URL;
// var root = process.env.ROOT_PATH
axios.defaults.withCredentials = false
axios.defaults.timeout = 5000;
//axios.defaults.baseURL = '/api/'  // api 即上面 vue.config.js 中配置的地址
// 引用axios
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

// 自定义判断元素类型JS
function toType(obj) {
    return {}.toString
        .call(obj)
        .match(/\s([a-zA-Z]+)/)[1]
        .toLowerCase();
}

// 参数过滤函数
function filterNull(o) {
    for (var key in o) {
        if (o[key] === null) {
            delete o[key];
        }
        if (toType(o[key]) === "string") {
            o[key] = o[key].trim();
        } else if (toType(o[key]) === "object") {
            o[key] = filterNull(o[key]);
        } else if (toType(o[key]) === "array") {
            o[key] = filterNull(o[key]);
        }
    }
    return o;
}

function configOptions(_config, options) {
    // console.log(_config)
    if (options) {
        if (options.timeout && options.timeout > 0) {
            _config.timeout = options.timeout;
        }
        if (options.canCancel) {

            _config.cancelToken = source.token;
        }
    }
}

function apiAxios(that, method, url, params, success, failure, showLoading = true, options) {
    if (params) {
        params = filterNull(params);
    }
    let _config = {
        method: method,
        url: url,
        data: method === "POST" || method === "PUT" ? params : null,
        params: method === "GET" || method === "DELETE" ? params : null,
        baseURL: root,

    };
    const token = localStorage.getItem("YY_TOKEN");
    if (token) {
        _config.headers = {
            "YY_TOKEN": token,
            "Content-Type": 'text/plain'
        }
    }
    configOptions(_config, options);
    axios(_config)
        .then(function (res) {
            // console.log(res)
            if (res.data && res.data.success) {
                if (res.data.success) {
                    if (success) {
                        // console.log(res.data);
                        success(res.data);
                    }
                } else {
                    if (failure) {
                        failure(res.data);
                    }
                }
            } else {

                if (failure) {
                    failure({
                        rspCode: 400,
                        rspDesc: "网络请求异常"
                    });
                }
            }
        })
        .catch(function (err) {
            if (axios.isCancel(err)) {
                return;
            }
            if (failure) {
                failure({
                    rspCode: 400,
                    rspDesc: "网络请求异常"
                });
            }
        });
}

function axiosFormUrl(that, method, url, params, success, failure, showLoading = true) {
    let headers = {
        'X-Requested-With': 'XMLHttpRequest',
    };
    const token = that.$route.query.YY_USER_ID;
    if (token) {
        headers.YY_USER_ID = token
    }
    // console.log(token);
    let _config = {
        method: method,
        url: url,
        params: params,
        baseURL: root,
        headers
    };
    configOptions(_config);
    // console.log(_config);
    axios(_config)
        .then(function (res) {
            // console.log(res)
            if (res.data && res.data.code === '0000') {
                if (success) {
                    // console.log(res);
                    success(res.data.data);
                }
            } else {
                if (failure) {
                    failure({
                        errno: 1000,
                        rspDesc: res.data.desc
                    });
                }
            }
        })
        .catch(function (err) {

            if (axios.isCancel(err)) {
                return;
            }
            if (failure) {
                failure({
                    rspCode: 400,
                    rspDesc: "网络请求异常"
                });
            }
        });
}

function axiosFormUrl2(that, method, url, params, success,failure, showLoading = true) {
    let headers = {
        'X-Requested-With': 'XMLHttpRequest',
    };
    const token = that.$route.query.YY_USER_ID;
    if (token) {
        headers.YY_USER_ID = token
    }
    // console.log(token);
    let _config = {
        method: method,
        url: url,
        params: params,
        baseURL: root,
        headers
    };
    configOptions(_config);
    // console.log(_config);
    axios(_config)
        .then(function (res) {
            // console.log(res)
            success(res);
        })
        .catch(function (err) {

            if (axios.isCancel(err)) {
                return;
            }
            if (failure) {
                failure({
                    rspCode: 400,
                    rspDesc: "网络请求异常"
                });
            }
        });
}

function axiosFormDataUrl(that, method, url, data, success, failure, showLoading = false) {
    let headers = {
        "content-type": "multipart/form-data",
    }
    const token = localStorage.getItem("YY_TOKEN");
    if (token) {
        headers.YY_TOKEN = token
    }
    let _config = {
        method: method,
        url: url,
        data: data,
        baseURL: root,
        headers
    };
    (_config);
    axios(_config)
        .then(function (res) {
            if (res.data && res.data.code === '0000') {
                if (success) {
                    // console.log(res);
                    success(res.data.data);
                }
            } else {
                if (failure) {
                    failure({
                        errno: 1000,
                        rspDesc: "网络请求异常"
                    });
                }
            }
        })
        .catch(function (err) {
            if (axios.isCancel(err)) {
                return;
            }
            if (failure) {
                failure({
                    rspCode: 400,
                    rspDesc: "网络请求异常"
                });
            }
        });
}

function corsGet(url,callback,onError) {
    var JSONP = document.createElement("script");
    JSONP.type = "text/javascript";
    var callbackName = "jsonpCallback" + new Date().getTime();
    window[callbackName] = callback;
    JSONP.src = url + "&callback=" + callbackName;
    JSONP.onerror = onError;
    document.getElementsByTagName("head")[0].appendChild(JSONP);
}

// 返回在vue模板中的调用接口
export default {
    postUrl: function (that, url, params, success, failure, showLoading) {
        return apiAxios(that, "POST", url, params, success, failure, showLoading);
    },
    postFormUrl: function (that, url, params, success, failure, showLoading) {
        return axiosFormUrl(that, "POST", url, params, success, failure, showLoading);
    },
    putFormUrl: function (that, url, params, success, failure, showLoading) {
        return apiAxios(that, "PUT", url, params, success, failure, showLoading);
    },
    getFormUrl: function (that, url, params, success, failure, showLoading) {
        return axiosFormUrl(that, "GET", url, params, success, failure, showLoading);
    },
    postFormDataUrl: function (that, url, data, success, failure, showLoading) {
        return axiosFormDataUrl(that, "POST", url, data, success, failure, showLoading);
    },
    cancelRequest: function () {
        source.cancel("api cancelRequest");
        source = CancelToken.source();
    },
    setUserId: function () {

    },
    corsGet: corsGet,
    get:function (that, url, params, success, failure, showLoading) {
        return axiosFormUrl2(that, "GET", url, params, success, failure, showLoading);
    },
}
;
